<template>
<div>
  <nav :class="['header',{'active':pathName !== '幸福家首页'}]">
    <div class="nav-box">
      <div class="nav-left">
        <!-- 幸福家logo -->
        <div class="logo-box">
          <router-link to="/">
            <!-- <img v-if="pathName === 'Home'" class="img-logo" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220525_17401945cb46e5312646f692d899f94d34534a.png"> -->
            <h1>
              <a href="https://xfj.coli688.com" class="img-logo">中海幸福家</a>
            </h1>
            <!-- <img class="img-logo" alt="中海幸福家" src="https://xfjoss.coli688.com/pc-images/big-footer.png"> -->
          </router-link>
        </div>
        <div class="location" @click="choseCityShow">
          <span class="location-word">{{ homePageName }}</span>
          <a-icon class="location-icon" :type="iconType" />
        </div>
        <ul class="nav-list">
          <li>
            <router-link to="/">首页</router-link>
          </li>
          <li>
            <router-link :to="{ name: '中海新房' }" :class="{'router-link-exact-active router-link-active': pathName === '中海新房' || pathName === '项目详情'}">中海新房</router-link>
          </li>
          <li>
            <router-link to="/headLine" :class="{'router-link-exact-active router-link-active': pathName === '中海头条' || pathName === '头条详情'}">中海头条</router-link>
          </li>
          <li>
            <a href="https://www.coli688.com" target="_Blank" rel="nofollow">中海地产</a>
          </li>
        </ul>
      </div>
      <div class="nav-right">
        <!-- <div class="right-item wx">前往小程序
          <div class="wx-popu">
            <img class="wx-img" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220525_1657160a1961657b354b839a19c5c8363396a3.png">
          </div>
        </div>
        <el-dropdown v-if="phone">
          <div class="right-item active"><i class="el-icon-user-solid"></i>{{ nickname || phone}}</div>
           <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logoutHandle()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <!-- <div class="right-item" @click="onLogin" v-else>登录/注册</div> -->
      </div>
    </div>
    <city-location ref="choseCityRef" v-model="showChoseCity"></city-location>
  </nav>
  <!-- <phone-login ref="login" v-if="loginVisible" @loginSubmit="getLoginInfo"></phone-login> -->
</div>
</template>

<script>
import Vue from 'vue'
import CityLocation from './CityLocation.vue'
// import PhoneLogin from './PhoneLogin.vue'
import { jsonp } from 'vue-jsonp'
import { mapGetters } from 'vuex'
export default {
  name: 'QzlHeader',
  components: {
    CityLocation,
    // PhoneLogin
  },
  data () {
    return {
      loginVisible: false,
      pathName: '幸福家首页',
      showChoseCity: false,
      phone: null,
      nickname: null,
      visible: true,
    }
  },
  watch: {
    '$route.path' () {
      this.pathName = this.$route.name
    },
  },
  computed: {
    ...mapGetters(['homePage']),
    homePageName () {
      return this.homePage ? this.homePage.name : ''
    },
    iconType () {
      return this.showChoseCity ? 'up' : 'down'
    },
  },
  mounted () {
    this.pathName = this.$route.name
  },
  created () {
    this.phone = this.geTel(Vue.cookie.get('phone'))
    this.nickname = Vue.cookie.get('nickname')
    this.getLocation()
  },
  methods:{
    geTel(tel){
      if (!tel) {
        return null
      }
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      return tel.replace(reg, "$1****$2");
    },
    getLoginInfo(){
      this.phone = this.geTel(Vue.cookie.get('phone'))
      this.nickname = Vue.cookie.get('nickname')
    },
    onLogin (){
      this.loginVisible = true;
      this.$nextTick(() => {
        this.$refs.login.init();
      });
    },
    choseCityShow () {
      this.showChoseCity = true
      this.$nextTick(() => {
        this.$refs.choseCityRef.init();
      });
    },
    // 获取当前定位城市名称
    getLocation(){
      var data = {key: "WDTBZ-EOPRG-5ONQY-IDVMO-NXIIK-C4B7A"};
      var url = "https://apis.map.qq.com/ws/location/v1/ip"; //这个就是地理位置信息的接口
      data.output = "jsonp";
      jsonp(url, data)
      .then(res => {
        const ipAddress = res.result.ip
        sessionStorage.setItem('ip_address', ipAddress)
        const cityName = res.result.ad_info.city || '深圳'
        this.getCityId(cityName)
      })
      .catch(error => {
        console.log(error)
        this.getCityId('深圳')
      });
    },
    getCityId(cityName){
      this.$api.getCityId({ cityName }).then(res => {
        const cityId = res.data || '1988'
        this.$store.commit('SET_CITYID', cityId)
        this.gethomePageId(cityId)
      })
    },
    // 获取城市HomePageId
    gethomePageId(cityId){
      this.$api.getExhibitionHallHomeId(cityId).then(res => {
        this.$store.commit('SET_HOMPAGEID', res.data)
      })
    },
    //退出登录
    logoutHandle() {
      this.$notify({
        title: "成功",
        message: "退出成功",
        type: "success",
        duration: 2000
      })
      this.phone = null
      this.nickname = null
      this.$cookie.delete("phone")
      this.$cookie.delete("nickname")
    }
  }
}
</script>

<style lang="scss" scoped>
nav{
  width: 100%;
  height:80px;
  background: #FFFFFF;
  position: relative;
  color: #FFFFFF;
  z-index: 500;
  // &.active{
  //  background: #303035;
  // }
}
.nav-box{
  width: 1180px;
  padding: 0 12px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  .nav-left{
    display: flex;
    .logo-box{
      width: 120px;
      height: 100%;
      display: flex;
      align-items: center;
      a{
        display: flex;
        align-items: center;
        color: #fff;
      }
      .img-logo{
        background-image: url('https://xfjoss.coli688.com/pc-images/big-footer.png');
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: cover;
        display: block;
        width: 82px;
        height: 42px;
        overflow: hidden;
        font-size: 0;
      }
    }
    .location {
      width: 82px;
      height: 32px;
      border-radius: 28px;
      @include font16(400, #BDA26C);
      // background: rgba(0, 0, 0, 0.5);
      line-height: 32px;
      text-align: center;
      margin: auto;
      cursor: pointer;
    }
    .location-word:hover {
      border-bottom: 1px solid white;
    }
    .location-icon {
      font-size: 12px;
      margin-left: 5px;
      transform:scale(0.9);
    }
    .nav-list{
      height: 100%;
      margin-left: 116px;
      display: flex;
      align-items: center;
      li{
        text-align: center;
        height: 80px;
        line-height: 80px;
        // margin-right: 32px;
        // width: 100px;
        a{
          display: inline-block;
          // padding: 0 4px;
          height: 80px;
          font-size: 18px;
          font-weight: 700;
          color: #434B5B;
          letter-spacing:2px;
          position: relative;
          width: 112px;
          font-family: 'Microsoft YaHei','Helvetica Neue', 'Hiragino Sans GB',  黑体, Arial, sans-serif;
          &:hover{
           color: #BDA26C;
          }
          &.router-link-exact-active.router-link-active{
            background-color: #BDA26C;
            color: #fff;
            // &::before{
            //   content: '';
            //   position: absolute;
            //   left: 0;
            //   bottom: 0;
            //   width: 100%;
            //   height: 3px;
            //   background: linear-gradient(270deg, #BDA26C 0%, #FFF0D3 100%);
            // }
          }
        }
      }
    }
  }
  .nav-right{
    display: flex;
    align-items: center;
    line-height: 80px;
    font-size:16px;
    font-weight: 400;
    .right-item{
      height: 20px;
      line-height: 20px;
      margin-left: 32px;
      cursor: pointer;
      &:hover{
        text-decoration:underline;
      }
      &.wx{
        position: relative;
        &:hover{
          text-decoration:underline;
          .wx-popu{
            display: block;
          }
        }
        .wx-popu{
          display: none;
          position: absolute;
          top: 40px;
          left: -30px;
          width: 136px;
          height: 176px;
          .wx-img{
            width: 136px;
            height: 176px;
          }
        }
      }
      &.active{
        i{
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
